import script from "./OrganizationUsersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationUsersTable.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationUsersTable.vue?vue&type=style&index=0&id=1565ba7a&scoped=true&lang=css"
script.__scopeId = "data-v-1565ba7a"

export default script